import { useLocation } from 'react-router-dom';
import { GRUPOS } from './Navegacao.js';
import { NOME_ATOR_PLACEHOLDER } from '../../lib/ator.js';

interface EntradaBreadcrumb {
  grupo: string | null;
  pagina: string;
}

function breadcrumbPara(caminho: string): EntradaBreadcrumb | null {
  for (const grupo of GRUPOS) {
    const item = grupo.itens.find((i) => i.rota === caminho);
    if (item) return { grupo: grupo.titulo, pagina: item.label };
  }
  return null;
}

// SPEC-UX §2.4 — barra de topo em todas as páginas: breadcrumb dinâmico
// (derivado da mesma fonte que o item ativo do sidebar, sem lista
// duplicada) + avatar. Sem timer/timesheet: não existem no domínio ainda,
// e a UI nunca mostra estado que não vem de um caso de uso real (§0).
export function BarraTopo() {
  const location = useLocation();
  const entrada = breadcrumbPara(location.pathname);
  const inicial = NOME_ATOR_PLACEHOLDER.charAt(0).toUpperCase();

  return (
    <div className="flex h-11 shrink-0 items-center justify-between border-b border-borda bg-superficie px-6">
      <div className="flex items-center gap-1.5 text-[12.5px] text-grafite">
        <span>COMPASSO</span>
        {entrada?.grupo && (
          <>
            <span aria-hidden="true">›</span>
            <span>{entrada.grupo}</span>
          </>
        )}
        {entrada && (
          <>
            <span aria-hidden="true">›</span>
            <span className="font-semibold text-ink">{entrada.pagina}</span>
          </>
        )}
      </div>
      <div
        className="flex h-[26px] w-[26px] items-center justify-center rounded-full bg-aco text-[11px] font-bold text-white"
        title={NOME_ATOR_PLACEHOLDER}
      >
        {inicial}
      </div>
    </div>
  );
}
